"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isLightColor = function (color) {
    if (!color || typeof color !== 'string' || !color.startsWith('#'))
        return false;
    var rgb = parseInt(color.slice(1), 16);
    var r = (rgb >> 16) & 0xff;
    var g = (rgb >> 8) & 0xff;
    var b = (rgb >> 0) & 0xff;
    var brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 150;
};
var Button = {
    baseStyle: {
        fontWeight: 'medium',
        borderRadius: 'lg',
        _disabled: {
            opacity: 0.6,
            cursor: 'not-allowed',
            _hover: {
                bg: 'unset',
                color: 'unset',
            },
        },
    },
    sizes: {
        sm: {
            fontSize: '13px',
            lineHeight: 4,
            py: 2,
            px: 4,
        },
        md: {
            fontSize: 'md',
            py: 2,
            px: 4,
        },
        lg: {
            fontSize: 'md',
            py: 5,
            px: 6,
        },
    },
    variants: {
        brand: function (props) {
            var _a = props.theme.colors.brand, primaryButton = _a.primaryButton, secondaryButton = _a.secondaryButton;
            var textColor = isLightColor(primaryButton) ? '#000' : '#fff';
            var hoverTextColor = isLightColor(secondaryButton) ? '#000' : '#fff';
            return {
                bg: 'brand.primaryButton',
                color: textColor,
                _hover: {
                    bg: 'brand.secondaryButton',
                    color: hoverTextColor,
                    _disabled: {
                        bg: 'brand.primaryButton',
                        color: textColor,
                        cursor: 'not-allowed',
                    },
                },
            };
        },
        outline: {
            border: '2px solid',
            borderColor: 'black.900',
            color: 'black.900',
            bg: '#fff',
            _hover: {
                borderColor: 'gray.400',
                color: 'gray.400',
                bg: '#fff',
                _disabled: {
                    borderColor: 'black.900',
                    color: 'black.900',
                    bg: '#fff',
                    cursor: 'not-allowed',
                },
            },
        },
        primary: {
            bg: 'blackAlpha.900',
            color: '#fff',
            _hover: {
                bg: 'gray.700',
                _disabled: {
                    bg: 'blackAlpha.900',
                    color: '#fff',
                    cursor: 'not-allowed',
                },
            },
        },
        secondary: {
            bg: 'blue.100',
            color: 'blue.800',
            _hover: {
                bg: 'blue.100',
                _disabled: {
                    bg: 'blue.100',
                    color: 'blue.800',
                    cursor: 'not-allowed',
                },
            },
        },
        success: {
            bg: 'green.500',
            color: '#fff',
            _hover: {
                bg: 'green.400',
                _disabled: {
                    bg: 'green.500',
                    color: '#fff',
                    cursor: 'not-allowed',
                },
            },
        },
        action: {
            bg: 'blue.600',
            color: '#fff',
            _hover: {
                bg: 'blue.600',
                _disabled: {
                    bg: 'blue.600',
                    color: '#fff',
                    cursor: 'not-allowed',
                },
            },
        },
        link: {
            color: 'blue.600',
            backgroundColor: 'transparent',
            _hover: {
                textDecoration: 'underline',
                bg: 'transparent',
                _disabled: {
                    color: 'blue.600',
                    bg: 'transparent',
                    cursor: 'not-allowed',
                    opacity: 0.5,
                },
            },
            _active: {
                backgroundColor: 'transparent',
            },
        },
        neutral: {
            bg: 'gray.highlight',
            color: 'black.darkest',
            _hover: {
                bg: 'gray.medium',
                _disabled: {
                    bg: 'gray.highlight',
                    color: 'black.darkest',
                    cursor: 'not-allowed',
                },
            },
        },
        caution: {
            bg: 'yellow.highlight',
            color: 'yellow.darkest',
            _hover: {
                bg: 'yellow.light',
                _disabled: {
                    bg: 'yellow.highlight',
                    color: 'yellow.darkest',
                    cursor: 'not-allowed',
                },
            },
        },
        danger: {
            bg: 'red.600',
            color: '#fff',
            _hover: {
                bg: 'red.400',
                _disabled: {
                    bg: 'red.600',
                    color: '#fff',
                    cursor: 'not-allowed',
                },
            },
        },
    },
    defaultProps: {
        size: 'md',
    },
};
exports.default = Button;
